import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { routes } from '../../../../config/routes/routes';
import {
  LocalStorageKey,
  setLocalStorageValue,
} from '../../../utils/localStorage/localStorage';

export const CatchLogin = () => {
  const location = useLocation();
  const attempted = location.pathname + location.search + location.hash;

  setLocalStorageValue(LocalStorageKey.postLoginRedirect, attempted);

  return <Navigate to={routes.auth.login} replace state={{ from: location }} />;
};
